module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/core-js/modules/_library.js
// module id = 59
// module chunks = 0